import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import classNames from "classnames";
import { convertTimeToLocation, convertUTCToLocal, getBrowserTimeZone } from "../../common/constant/constant";

const CalendarEvent = ({ event, onClick, style }) => {
  
  const { patientName, phoneNumber, eventName, startTime, endTime, isOpen, trialName } = event;
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const LocStartTime = convertUTCToLocal(startTime)
  const LocEndTime = convertUTCToLocal(endTime)

 
  const isCanceled = !isOpen; 

  function isPastDateTime(startTime) {
    
    const utcDate = new Date(startTime.endsWith('Z') ? startTime : `${startTime}Z`);

  // Now it’s correctly interpreted as UTC and converted to local browser time
  const currentDate = new Date();

  

  return utcDate < currentDate;
  }

  return (
    <div
      className="relative w-full"
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      style={{ position: "absolute", ...style }}
    >
      {/* Event Label */}
      <div
        className={classNames(
          "active-meetings cursor-pointer relative px-2 py-1 text-white rounded-md",
          "transition-all duration-200",
          {
            "cancelled-meetings line-through bg-gray-400": isCanceled,
            "bg-blue-500": !isCanceled && !isPastDateTime(event.endTime),
            "bg-green": isPastDateTime(event.endTime) && !isCanceled,
          }
        )}
        onClick={(e) => {
          // Get position of clicked event
          const rect = e.currentTarget.getBoundingClientRect();
          onClick(event, { top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }}
      >
        <span className="font-semibold w-full block truncate">{isCanceled && <span className="font-bold">Canceled - </span>}{patientName} - {phoneNumber}</span>
        <span className="font-semibold block w-full truncate">{trialName}</span>
      </div>

      {/* Tooltip positioned at the bottom */}
      {isTooltipVisible && (
        <div className="calendarTooltip text-xs p-2 rounded shadow-md z-50">
          <p className="font-bold">{patientName} - {phoneNumber}</p>
          <p>{trialName}</p>
          <p>{LocStartTime.dateOnly} {LocStartTime.timeHHmm} - {LocEndTime.timeHHmm}</p>
        </div>
      )}
    </div>
  );
};

export default CalendarEvent;